<!-- Page Content AD Block-->
<section id="app" class="">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-8">
        <div class="app-text">
          <h3>Set Your Price For <br />Business Class Flights</h3>
          <p>
            The easiest and fastest way to get a quote and save up to 70% off
            business class flights. Download the app now!
          </p>
        </div>
        <div class="button-block">
          <a rel="noopener"
            href="https://itunes.apple.com/us/app/wholesale-flights/id1390982713?mt=8"
            target="_blank"
            class="app-button"
          ><span style="text-indent: 100%;white-space: nowrap;overflow: hidden; opacity: 0">Download Apple</span></a>
          <a rel="noopener"
            href="https://play.google.com/store/apps/details?id=com.wholesaleflights.android"
            target="_blank"
            class="app-button-play"
          ><span style="text-indent: 100%;white-space: nowrap;overflow: hidden; opacity: 0">Download Android</span></a>
          <a routerLink="/app-page" class="app-learn-more">Know more</a>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4 d-none d-md-block">
        <picture class="app-phone ">
          <source [attr.lazyLoad]="cdnPath + '/assets/img/iphone7@1x.webp'" type="image/webp">
          <img  width="250" height="510.39" class="app-phone"
                  [lazyLoad]="cdnPath + '/assets/img/iphone7@1x.png'"
                  alt=""
          />
        </picture>

      </div>
    </div>
  </div>
</section>
